import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { MadMarqueeProps } from "./typings";
import {
  CustomerNotification as InlineNotification,
  CustomerNotificationLocation as InlineNotificationLocation,
} from "@shared-ui/customer-notifications";
import { LazyLoad } from "components/utility/LazyLoad/LazyLoad";

export const MadMarquee = withStores(
  "flexModuleModelStore",
  "context",
  "page"
)(
  observer((props: MadMarqueeProps) => {
    const { page, context } = props;

    if (!page || !page.pageId) {
      return null;
    }

    return (
      <LazyLoad context={context}>
        <div className="MadMarqueeContainer">
          <InlineNotification
            inputs={{
              xPageId: page.pageId,
              notificationLocation: InlineNotificationLocation.FOOTER,
            }}
          />
        </div>
      </LazyLoad>
    );
  })
);

export default MadMarquee;
